import classNames from 'classnames';
import Link from 'next/link';
import { useParams } from 'next/navigation';
import React, { FC, useEffect, useState } from 'react';

import { languages } from '@/app/[lang]/dictionaries';
import Image from '@/components/core/Image';
import {
  STYLE_SINGLE_PAGE_CLOSE,
  STYLE_SINGLE_PAGE_OPEN,
} from '@/components/Layout/Header/MobileHeader/consts';
import { savePreferredLanguage } from '@/helpers';
import { useTranslation } from '@/hooks/useTranslations';
import { useVisiblePathname } from '@/hooks/useVisiblePathname';
import { getLanguageHref } from '@/lib/i18n';

interface LanguagesPage {
  setLangPageIsOpen: (state: boolean) => void;
  onClose: () => void;
}

const LanguagesPage: FC<LanguagesPage> = ({ setLangPageIsOpen, onClose }) => {
  const [style, setStyle] = useState<React.CSSProperties>(STYLE_SINGLE_PAGE_CLOSE);

  const { t } = useTranslation();
  const path = useVisiblePathname();
  const params = useParams();

  useEffect(() => {
    setStyle(STYLE_SINGLE_PAGE_OPEN);
  }, []);

  return (
    <div className="menuBurgerGamesInfoWrp" style={style}>
      <div className="menuBurgerHomeRow">
        <div className="menuBurgerHomeRowItem" onClick={() => setLangPageIsOpen(false)}>
          <i className="bc-i-arrow-left menuBurgerArrow" />
          <p className="menuBurgerHomeTitle">{t('languages')}</p>
        </div>
      </div>
      {languages.map((item, index) => (
        <Link
          key={item.link}
          href={getLanguageHref(path, params.lang as string, item.link)}
          prefetch={false}
          onClick={() => {
            savePreferredLanguage(item.link);
            onClose();
          }}
        >
          <div
            key={index}
            className={classNames('menuBurgerHomeRowItem', {
              active: item.link === params.lang,
            })}
          >
            <div className="countyFlag">
              <Image src={item.flag} width={30} height={22} alt="" />
            </div>
            <div className="menuBurgerHomeRowItem" key={item.name}>
              <p className="menuBurgerGamesTitle">{t(item.name)}</p>
            </div>
            {item.link === params.lang && <i className="bc-i-check" style={{ color: 'white' }} />}
          </div>
        </Link>
      ))}
    </div>
  );
};

export default LanguagesPage;
